<template>
<div class="chapter">
<div class="inner_page">
<p class="chap">ACKNOWLEDGEMENTS</p>
<p class="noindent">Compiling a book takes lots of energy, patience, time and help. I would like to thank the following people for their generosity:</p>
<p class="indent">Heather Trentzsch, assistant tournament director with the Pirate’s Cove Big Game Tournament, patiently answered my questions and provided me with access to old tournament programs.</p>
<p class="indent">John M. Havel, lighthouse researcher par excellence, shared his research notes on the Cape Hatteras Lighthouse at a time when my idea well was running dry.</p>
<p class="indent">Brandon W. Stilley, library technician at Joyner Library, East Carolina University, provided requested materials promptly and professionally as the folks at Joyner <i>always</i> do.</p>
<p class="indent">Angie Brady-Daniels shared her memories and a photo of <i>The Today Show</i> visit.</p>
<p class="indent">Tori Murden McClure found me a photo of her first transatlantic rowboat trip.</p>
<p class="indent">Dr. Frank Blazich, fellow history geek, shared documents he uncovered at the State Archives of North Carolina.</p>
<p class="indent">Jacksonville, Florida’s Mitch Kauffman, aka The Mayor, fed my head with sweet stories of surf trips to Hatteras in the 1970s.</p>
<p class="indent">James Hussey from Tarboro recollected about his world-record bluefish catch.</p>
<p class="indent">Walter C. Gresham, Drew C. Wilson, Michelle Warren, Eve Trow Turek and Mike Booher granted permission to use their photographs. Big thanks!</p>
<p class="indent">Naomi Rhodes, reference librarian, Dare County Library, brokered information for me and was always cheerful and supportive.</p>
<p class="indent">Frank Edgcombe and Peggy Brown, Harvey Library, Hampton University, graciously mined old, obscure newspaper columns from the 1941 <i>New York Times</i>.</p>
<p class="indent">Deputy Kevin Duprey took time out to talk to me about his award-winning rescue.</p>
<p class="indent">Jami Lanier, archives technician for the National Park Service, Cape Hatteras Group, answered questions and helped locate photographs.</p>
<p class="indent">Connie Perkins, friend from the Prairie State, carefully read the manuscript and provided invaluable advice.</p>
<p class="indent">Stuart Parks II created an impressive map to supplement the text.</p>
<p class="indent">My brother, Stephen Spink, was always willing to listen and give advice.</p>
<p class="indent">Thanks especially to my husband, Steve, who cooked dinner many nights when I was busy writing.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?5d1d6444